// extracted by mini-css-extract-plugin
export default {"div":"checkboxSmall_div__Ra4pR","innerDiv":"checkboxSmall_innerDiv__cXk++","span":"checkboxSmall_span__pK856","p":"checkboxSmall_p__DKFQS","label":"checkboxSmall_label__axCDb"};